module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-pain1.04ab0095.png";